import React from 'react';
import ValidationHint from './Fragments/ValidationHint';
import ValidationError from './Fragments/ValidationError';
import Help from './Fragments/Help';
import { classNames } from '../../../Services/helpers';
import { useFormContext } from '../Provider';

const CommonFieldWrapper = ({children, value, label, help, isValid, isValidating, error, validators, isDisabled, footer, padding = 'px-3 py-2.5', focusRing = true}) => {

    const formContext = useFormContext();

    return <div className={classNames(
            `relative rounded-md shadow-xs ring-1 ring-inset ring-gray-300 grow`,
            focusRing && 'focus-within:ring-2 focus-within:ring-brand',
            (formContext?.layout ?? 'no') === 'horizontal' ? '' : 'mt-3',
            padding,
            isDisabled && 'bg-gray-100 dark:bg-gray-800'
        )}>
        <label className="absolute -top-2 px-2 left-2 mr-2 inline-block rounded-sm text-xs font-medium text-pretty surface-1">
            {label}
            <ValidationHint isValid={isValid} validatable={!!(validators && validators.length > 0)} />
        </label>

        {children}

        <ValidationError error={error} isValidating={isValidating} />

        {footer}

        <Help help={help} value={value} />
    </div>
}

export default CommonFieldWrapper;
